// LazyLoadWrapper.js
import React, { useRef, useState, useEffect, Suspense, Fragment } from "react";
import ShimmerLoader from "../ShimmerLoader";

const MorphologySomaticGermline = React.lazy(() => import("."));

function MorphologySomaticGermlineLazyLoadWrapper(props) {
  const {somaticTotal,Fullscreen,somaticGermline, Highcharts,somaticgermline,
    MorphologySomaticGermlineLoader,morphPie ,morphologyData,morphTotalCount} = props;
  const containerRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // SomaticGermlineAPICall()
          observer.disconnect(); 

        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.3,
      }
    );
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => observer.disconnect();
  /* eslint-disable-next-line react-hooks/exhaustive-deps */    
  }, []);
  return (
    <Fragment>
      <div
       ref={containerRef} 
      //  style={{ minHeight: "500px" }}
      >
        {isVisible && (
          <Suspense fallback={<ShimmerLoader />}>
            {MorphologySomaticGermlineLoader === true && <ShimmerLoader />}
            {MorphologySomaticGermlineLoader === false && somaticGermline &&  <MorphologySomaticGermline
              somaticTotal={somaticTotal}
              Fullscreen={Fullscreen}
              somaticGermline={somaticGermline}
              Highcharts={Highcharts}
              somaticgermline={somaticgermline}
                morphologyData={morphologyData}
              morphTotalCount={morphTotalCount}
              morphPie={morphPie}
          
            />}
          </Suspense>
        )}
      </div>
    </Fragment>
  );
}

export default MorphologySomaticGermlineLazyLoadWrapper;
